import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { StickyHeaderService } from 'app/services/stickyHeaderService/stickyHeader.service';

@Injectable({providedIn: 'root'})
export class SnapshotResults implements ICommunicationEvent {
	constructor(
		private readonly stickyHeaderService: StickyHeaderService
	) {}

	get eventName(): string {
		return PlatformCommunicationEvents.SnapshotResults;
	}

    handleEvent(event: any): void {
		this.stickyHeaderService.snapshotResults$.next(event.data.snapshots);
    }
}